<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-toolbar text color="white">
          <v-toolbar-title>Commission Runs</v-toolbar-title>
          <v-divider class="mx-2" inset vertical></v-divider>
          <v-col md="2">
            <v-select
              label="Run Type"
              @change="getRuns"
              :items="[
                { value: 1, text: 'Initial' },
                { value: 2, text: 'Royalty' }
              ]"
              v-model="runType"
            ></v-select>
          </v-col>
          <v-spacer></v-spacer>
          <v-card>
            <v-btn color="primary" dark class="mb-2" @click="getRuns"
              >Refresh</v-btn
            >
            <v-btn color="primary" dark class="mb-2" @click="newRun(1)"
              >New Run</v-btn
            >
            <v-btn
              v-if="runType == 1"
              color="primary"
              dark
              class="mb-2"
              @click="newRun(5)"
              >Add 5 Runs</v-btn
            >
          </v-card>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on }"></template>
            <v-card>
              <app-title>New Run</app-title>

              <v-card-text>
                <v-container>
                  <v-row v-if="editedItem">
                    <v-col md="2">
                      <v-text-field
                        v-model="editedItem.runId"
                        label="Run Id"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col md="3">
                      <v-text-field
                        v-model="editedItem.runType"
                        label="Run Type"
                        disabled
                      ></v-text-field>
                    </v-col>
                    <v-col md="4">
                      <v-checkbox
                        label="Approved To Pay"
                        v-model="editedItem.approvedToPay"
                      >
                      </v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <!-- <v-col cols="4" v-if="runType == 1"> -->
                      <strong>From:</strong>
                      <date-picker
                        lang="en-au"
                        format="DD/MM/YYYY"
                        placeholder="dd/MM/YYYY"
                        v-model="editedItem['dateFrom']"
                        v-validate="'required'"
                        editable
                        locale="en-au"
                        data-vv-validate-on="blur"
                        name="dateFrom"
                      />
                    </v-col>
                    <v-col cols="6">
                      <!-- <v-col cols="4" v-if="runType == 1"> -->
                      <strong>To:</strong>
                      <date-picker
                        lang="en-au"
                        format="DD/MM/YYYY"
                        placeholder="dd/MM/YYYY"
                        v-model="editedItem['dateTo']"
                        v-validate="'required'"
                        editable
                        data-vv-validate-on="blur"
                        name="dateTo"
                      />
                    </v-col>
                    <v-col cols="6">
                      <!-- <v-col cols="4" v-if="runType == 1"> -->
                      <strong>Date Issued:</strong>
                      <date-picker
                        lang="en-au"
                        format="DD/MM/YYYY"
                        placeholder="dd/MM/YYYY"
                        v-model="editedItem['dateIssued']"
                        v-validate="'required'"
                        locale="en-au"
                        editable
                        data-vv-validate-on="blur"
                        name="dateIssued"
                      />
                    </v-col>
                    <v-col md="6" v-if="runType == 2">
                      <v-text-field
                        type="number"
                        name="statementFrom"
                        label="Statement From"
                        v-model.number="editedItem.statementFrom"
                      ></v-text-field>
                    </v-col>
                    <v-col md="6" v-if="runType == 2">
                      <v-text-field
                        type="number"
                        name="statementTo"
                        label="Statement To"
                        v-model.number="editedItem.statementTo"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-data-table
          :headers="runHeaders"
          :items="items.filter(x => x.runType == runType)"
          class="elevation-1"
        >
          <template v-slot:item="{ item, headers, index }">
            <tr>
              <td
                :class="`text-xs-${name.align}`"
                v-for="(name, index) in headers"
                :key="index"
              >
                <span v-if="name.value.includes('date')">
                  {{ item[name.value] | formatDate }}
                </span>
                <span v-else>{{ item[name.value] }}</span>
              </td>
              <td>
                <v-icon class="mr-2" @click="editItem(item)">edit</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import CommissionRun from "@/models/CommissionRun";
export default {
  name: "EditRuns",
  components: {
    DatePicker
  },
  data() {
    return {
      dialog: false,
      runType: 1,
      items: [],
      editedItem: {},
      headers: [
        {
          text: "Run ID",
          value: "runId",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80,
          bothRunType: true
        },
        {
          text: "Date From",
          value: "dateFrom",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80,
          bothRunType: true
        },
        {
          text: "Date To",
          value: "dateTo",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80,
          bothRunType: true
        },
        {
          text: "Date Issued",
          value: "dateIssued",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80,
          bothRunType: true
        },
        {
          text: "Statement From",
          value: "statementFrom",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80,
          bothRunType: false
        },
        {
          text: "Statement To",
          value: "statementTo",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80,
          bothRunType: false
        },
        {
          text: "Run Type",
          value: "runType",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80,
          bothRunType: true
        },
        {
          text: "Approved to Pay",
          value: "approvedToPay",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80,
          bothRunType: true
        }
      ]
    };
  },
  computed: {
    runHeaders() {
      if (this.runType === 1)
        return this.headers.filter(x => x.bothRunType == true);

      return this.headers;
    }
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    newRun(val) {
      if (val == 1) {
        this.editedItem = this.newCommsRun(1);
        this.dialog = true;
      } else {
        let newRuns = [];
        for (let index = 1; index < 6; index++) {
          newRuns.push(this.newCommsRun(index));
        }
        this.save(newRuns);
      }
    },
    newCommsRun(val) {
      let items = this.items.filter(x => x.runType == this.runType);
      let maxRun = items
        .map(el => el.runId)
        .reduce((a, c) => {
          return Math.max(a, c);
        });
      let maxDates = items.filter(x => x.runId == maxRun);
      let dateTo = new Date(maxDates[0].dateTo);
      let dateFrom = new Date(maxDates[0].dateFrom);
      let y = dateTo.getFullYear();
      let m = dateTo.getMonth();

      // let to = new Date(Date.parse(maxDates[0].dateTo));
      let run = new CommissionRun({
        id: 0,
        runId: maxRun + val,
        dateFrom:
          this.runType !== 1
            ? new Date(y, m + 1, 1)
            : new Date(
                dateFrom.setDate(dateFrom.getDate() + (val - 1) * 7 + 7)
              ),
        dateTo:
          this.runType !== 1
            ? new Date(y, m + 2, 0)
            : new Date(dateTo.setDate(dateTo.getDate() + (val - 1) * 7 + 7)),
        dateIssued:
          this.runType !== 1
            ? new Date(y, m + 3, 0)
            : new Date(dateTo.setDate(dateTo.getDate() + (val - 1) * 7 + 7)),
        runType: this.runType,
        statementFrom: maxDates[0].statementTo + 1,
        statementTo: maxDates[0].statementTo + 0,
        amount: 0.0
      });

      return run;
    },

    close() {
      this.dialog = false;
    },
    save(body) {
      this.saveRuns(body ? body : [this.editedItem]);
    },
    getProperDate(value) {
      var date = new Date(value);
      return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    },
    saveRuns(body) {
      body[0].dateFrom = this.getProperDate(body[0].dateFrom);
      body[0].dateTo = this.getProperDate(body[0].dateTo);
      body[0].dateIssued = this.getProperDate(body[0].dateIssued);
      let query = {
        message: `Runs added`,
        url: `Commissions/EditCommsRun/`,
        method: "post",
        body: body
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data;
          this.dialog = false;
        })
        .catch(() => {});
    },
    getRuns() {
      let query = {
        message: `Runs collected`,
        url: `Commissions/GetRuns/${this.runType}`,
        method: "get",
        body: {}
      };
      this.CommissionsRequest(query)
        .then(data => {
          this.$emit("collected");
          this.items = data;
        })
        .catch(() => {});
    },
    editItem(val) {
      this.editedItem = Object.assign({}, val);
      this.dialog = true;
    }
  },
  mounted() {
    // this.getRuns();
  }
};
</script>

<style scoped></style>
